import React from 'react';
import { TInfoClient } from '../../store/users/types';
import { AnimatedClasses } from '../../utils/animatedStyles';
import { useCloseModal } from './hooks/useCloseModal';
import * as Styles from './styles';
import styled from 'styled-components';

interface UserInfoProps {
  client: TInfoClient;
  closeHandler: () => void;
}

export const UserInfo: React.FC<UserInfoProps> = ({ client, closeHandler }) => {
  const { refInnWrapper, closeModal } = useCloseModal(closeHandler);

  return (
    <Styles.ModalOuterWrapperS>
      <Styles.ModalInnerWrapperS style={{ maxWidth: '500px' }} ref={refInnWrapper} className={AnimatedClasses.zoomIn}>
        <div style={{ padding: '5px', textAlign: 'right' }}>
          <i style={{ cursor: 'pointer', fontSize: '25px' }} className="bi bi-x" onClick={closeModal} />
        </div>
        <Styles.ModalBodyS>
          <WrapItem>
            <StyleItem>
              <SpanS>ПІБ:</SpanS>
            </StyleItem>
            <StyleItem>{client.fio}</StyleItem>
          </WrapItem>
          <WrapItem>
            <StyleItem>
              <SpanS>Компанія:</SpanS>
            </StyleItem>
            <StyleItem>{client.company}</StyleItem>
          </WrapItem>
          <WrapItem>
            <StyleItem>
              <SpanS>Посада:</SpanS>
            </StyleItem>
            <StyleItem>{client.post}</StyleItem>
          </WrapItem>
        </Styles.ModalBodyS>
        <Styles.ModalFooterS></Styles.ModalFooterS>
      </Styles.ModalInnerWrapperS>
    </Styles.ModalOuterWrapperS>
  );
};

const WrapItem = styled.div`
  display: flex;
  width: 100%;
`;

const StyleItem = styled.div`
  width: 50%;
  text-align: start;
  margin: 5px 5px;
`;

const SpanS = styled.span`
  font-weight: bold;
`;
